import Cleave from 'cleave.js/react';
import { AccordionBodyItem } from 'component/Accordion';
import { Table, TableHeader, TableRow } from 'component/Table';
import { React, useEffect } from 'react';
import { calculateBeneficiariesSum } from 'utils/Helper';

export const IndirectBeneficiaries = (props) => {
  const beneficiaries = props.formData.info.landuse_and_beneficiaries;

  useEffect(() => {
    props.setBeneficiariesSum(() => calculateBeneficiariesSum(beneficiaries, 'number_of_indirect_beneficiaries'));
  });

  const handleBeneficiaryChange = (category, value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        landuse_and_beneficiaries: {
          ...prevFormData.info.landuse_and_beneficiaries,
          number_of_indirect_beneficiaries: {
            ...prevFormData.info.landuse_and_beneficiaries.number_of_indirect_beneficiaries,
            [category]: Number(value),
          },
        },
      },
    }));
  };
  return (
    <div className="flex-column-group">
      <AccordionBodyItem
        accordionSubId=""
        titleUA="Кількість непрямих бенефіціарів"
        titleEN="Number of indirect beneficiaries"
      />
      <Table>
        <TableHeader>
          <th>
            <div>8.12 Чоловіків (18 та старше)</div>
            <div>
              Men (18+)
              <span className="star">*</span>
            </div>
          </th>
          <th>
            <div>8.13 Жінок (18 та старше)</div>
            <div>
              Women (18+)
              <span className="star">*</span>
            </div>
          </th>
          <th>
            <div>8.14 Хлопчиків (молодше 18)</div>
            <div>
              Boys
              <span className="star">*</span>
            </div>
          </th>
          <th>
            <div>8.15 Дівчаток (молодше 18)</div>
            <div>
              Girls
              <span className="star">*</span>
            </div>
          </th>
        </TableHeader>
        <tbody>
          <TableRow>
            <td aria-label="text-box">
              <Cleave
                placeholder="0"
                id="indirectBeneficiaries-men"
                name="men"
                className="number"
                value={beneficiaries.number_of_indirect_beneficiaries?.men || 0}
                autoComplete="off"
                options={{
                  numericOnly: true,
                  stripLeadingZeroes: true,
                }}
                onChange={(e) => handleBeneficiaryChange('men', e.target.value.replace(/^0+/, ''))}
                disable="false"
              />
            </td>
            <td aria-label="text-box">
              <Cleave
                placeholder="0"
                id="indirectBeneficiaries-women"
                name="women"
                className="number"
                value={beneficiaries.number_of_indirect_beneficiaries?.women || 0}
                autoComplete="off"
                options={{
                  numericOnly: true,
                  stripLeadingZeroes: true,
                }}
                onChange={(e) => handleBeneficiaryChange('women', e.target.value.replace(/^0+/, ''))}
                disable="false"
              />
            </td>
            <td aria-label="text-box">
              <Cleave
                placeholder="0"
                id="indirectBeneficiaries-boys"
                name="boys"
                className="number"
                value={beneficiaries.number_of_indirect_beneficiaries?.boys || 0}
                autoComplete="off"
                options={{
                  numericOnly: true,
                  stripLeadingZeroes: true,
                }}
                onChange={(e) => handleBeneficiaryChange('boys', e.target.value.replace(/^0+/, ''))}
                disable="false"
              />
            </td>
            <td aria-label="text-box">
              <Cleave
                placeholder="0"
                id="indirectBeneficiaries-girls"
                name="girls"
                className="number"
                value={beneficiaries.number_of_indirect_beneficiaries?.girls || 0}
                autoComplete="off"
                options={{
                  numericOnly: true,
                  stripLeadingZeroes: true,
                }}
                onChange={(e) => handleBeneficiaryChange('girls', e.target.value.replace(/^0+/, ''))}
                disable="false"
              />
            </td>
          </TableRow>
        </tbody>
      </Table>
    </div>

  );
};
